import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum UpdateOperationType {
  SET = "set",
  ADD_TO_SET = "addToSet",
  PULL_ALL = "pullAll",
}

export const PendingUpdateSchema = z.object({
  type: createEnum(UpdateOperationType),
  path: z.string(),
  value: z.any(),
});

export type PendingUpdate = z.infer<typeof PendingUpdateSchema>;
